var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns columns--full is-vcentered onboarding-create-site__step5"},[_c('div',{staticClass:"column onboarding-create-site__description has-text-centered"},[_c('h1',{staticClass:"onboarding-create-site__title"},[_vm._v(" Ótimo, já estamos preparando seu site ")])])])
}]

export { render, staticRenderFns }